var $00a762770727e184$exports = {};
$00a762770727e184$exports = {
    "endTime": `Kone\u{10D}n\xfd \u{10D}as`,
    "startTime": `Po\u{10D}\xe1te\u{10D}n\xed \u{10D}as`,
    "time": `\u{10C}as`
};


export {$00a762770727e184$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
